module.exports = __webpack_public_path__ + "img/p9.365fa8ce.png";